module.exports = __webpack_public_path__ + "img/imprint.a1d8098c.png";